import HomeFloorBox from './home-floor-box';
import ColorCard from './color-card';
import React from 'react';
import {HomeGameCardItem} from '@/pages/home/home.type';

interface HomeFloorColorProps {
  name: string;
  id: string;
  serverTime?: number;
  shown?: boolean;
  games: HomeGameCardItem[];
  categoryPic?: string;
}

const HomeFloorColor = ({
  name,
  id,
  categoryPic,
  games = [],
  serverTime = 0,
}: HomeFloorColorProps) => {
  const timer = React.useRef<NodeJS.Timeout>();
  const currentRef = React.useRef(0);
  const [currentTime, setCurrentTime] = React.useState(0);

  React.useEffect(() => {
    if (serverTime && serverTime > 0) {
      startRemaining(serverTime);
    }
  }, [serverTime]);

  const startRemaining = (time = 0) => {
    timer.current && clearInterval(timer.current);
    currentRef.current = time;
    setCurrentTime(currentRef.current);
    timer.current = setInterval(() => {
      currentRef.current = currentRef.current + 1000;
      setCurrentTime(currentRef.current);
    }, 1000);
  };

  React.useEffect(() => {
    return () => {
      timer.current && clearInterval(timer.current);
    };
  }, []);
  return (
    <HomeFloorBox
      gameType="color"
      id={id}
      name={name}
      categoryPic={categoryPic}>
      <div className="flex flex-row overflow-auto gap-2">
        {games.map((item, _i) => (
          <ColorCard
            key={_i}
            v={item}
            i={_i}
            serverTime={serverTime}
            currentTime={currentTime}
          />
        ))}
      </div>
    </HomeFloorBox>
  );
};

export default HomeFloorColor;
